import { createPublicClient, defineChain, http } from 'viem';
import type { Chain } from 'viem';
import { anvil, robinhood } from 'viem/chains';
import { deployments } from '@hashcurve/protocol';
import type { Deployment } from '@hashcurve/protocol';
import { CHAIN_ID, RPC_URL } from './env';

const KNOWN: Record<number, Chain> = { 31337: anvil, 4663: robinhood };

function chainFor(id: number): Chain {
  const known = KNOWN[id];
  const rpcUrls = { default: { http: [RPC_URL] } };
  if (known) return defineChain({ ...known, rpcUrls });
  return defineChain({
    id,
    name: `Chain ${id}`,
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls,
  });
}

export const chain = chainFor(CHAIN_ID);
export const isLocalChain = CHAIN_ID === 31337;

/** Contract addresses for the selected chain, or null if HASHCURVE is not deployed there. */
export const deployment: Deployment | null = deployments[String(CHAIN_ID)] ?? null;

/** One HTTP transport with JSON-RPC batching; used for every read in the app. */
export const publicClient = createPublicClient({
  chain,
  transport: http(RPC_URL, { batch: { wait: 16 } }),
  pollingInterval: 1_000,
});

export function explorerTx(hash: string): string | null {
  const url = chain.blockExplorers?.default.url;
  return url ? `${url}/tx/${hash}` : null;
}

export function explorerAddress(address: string): string | null {
  const url = chain.blockExplorers?.default.url;
  return url ? `${url}/address/${address}` : null;
}
